import React from 'react';
import { Provider } from 'react-redux';
import { store } from './app/store';
import GoogleDrivePicker from './components/GoogleDrivePicker';
import './App.css';

function App() {
  return (
    <Provider store={store}>
      <div className="App">
        <header className="App-header">
          <h1>Google Drive File Picker with React & Redux</h1>
          <GoogleDrivePicker />
        </header>

        <footer className="App-footer">
          <a
            href="/terms-of-service.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          <span>|</span> {/* This is just a separator */}
          <a
            href="/privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </footer>
      </div>
    </Provider>
  );
}

export default App;